import { useQuery, keepPreviousData } from "@tanstack/react-query";
import {
  UserProfileDto,
  UserRole,
  DoubleMaterialityResultRowDto,
} from "@green0meter/api-client";

import { DOMAIN_DOUBLE_MATERIALITY } from "../domain";

import { roleGuard } from "@api";
import { doubleMaterialityResultsApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";

export const ACTION_GET_RESULTS = "GET_RESULTS";

export type DoubleMaterialityResultRow = DoubleMaterialityResultRowDto;

const fetchResults = async (year: number): Promise<DoubleMaterialityResultRow[]> => {
  const response =
    await doubleMaterialityResultsApi.doubleMaterialityResultsControllerGetResults(
      year,
    );

  return response.data ?? [];
};

export const useGetResults = (
  user: UserProfileDto | null,
  params: { year: number },
): {
  results?: DoubleMaterialityResultRow[];
  isPendingResults: boolean;
  resultsEnabled: boolean;
  refetchResults: () => void;
} => {
  const enabled = roleGuard(user, [UserRole.Owner, UserRole.Manager]);
  const year = params.year;

  const { data, isPending, refetch } = useQuery({
    queryKey: [DOMAIN_DOUBLE_MATERIALITY, ACTION_GET_RESULTS, year],
    queryFn: () => fetchResults(year),
    enabled: enabled && Number.isFinite(year),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    placeholderData: keepPreviousData,
  });

  return {
    results: data,
    isPendingResults: isPending,
    resultsEnabled: enabled,
    refetchResults: refetch,
  };
};
